<template>
  <div class="collapse-item">
    <div class="collapse-trigger" :class="{'collapse-trigger__active': expanded}" @click="toggleCollapse">
      <slot name="collapse-trigger"></slot>
    </div>

    <transition name="collapse"
                @enter="onExpand" @after-enter="onCollapse"
                @before-leave="onExpand" @after-leave="onCollapse">
      <div class="collapse-content" v-show="expanded">
        <slot name="collapse-content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CollapseItem",
  data()
  {
    return {
      expanded: false
    }
  },
  methods: {
    toggleCollapse()
    {
      this.expanded = !this.expanded;
    },
    onCollapse(el)
    {
      el.style.height = "";
    },
    onExpand(el)
    {
      el.style.height = `${el.scrollHeight}px`;
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-trigger
{
  cursor: pointer;
}

.collapse-enter-active,
.collapse-leave-active
{
  will-change: height, opacity;
  transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to
{
  height: 0 !important;
  opacity: 0;
}
</style>